<template>
    <section class="layout layout-scale" :class="{ 'opacity-0': !isAlreadyShow }">
        <div class="relative">
            <QuizHeader :title="title" :currentQuizIndex="playingCurrentQuestionIndex" :questionCount="questionCount" />
            <div class="header-tool flex items-center absolute h-full">
                <div @click="openLiveShare()" class="cursor-pointer pr-4">
                    <i
                        id="share-summary-result"
                        class="theme-question-shadow fas fa-tv text-white font-size-14 theme-ui-text-color"
                    ></i>
                </div>

                <UserCounter
                    :show-sound="masterSound.effectMusic || masterSound.questionMusic"
                    :counter="currentPlayers"
                    class="pr-4"
                />

                <BgMusicMuteBtn
                    v-if="masterSound.effectMusic || masterSound.questionMusic"
                    :is-muted="isMuted"
                    :is-spotify="isSoundQuestion"
                    style="position: unset"
                    class="pr-4"
                ></BgMusicMuteBtn>

                <div
                    @click="showQuizSettingModal = true"
                    class="flex justify-center items-center cursor-pointer setting-icon"
                >
                    <i class="theme-ui-text-color theme-question-shadow fas fa-cog font-size-18 mr-2 text-white"></i>
                </div>
            </div>
        </div>

        <div class="content mx-0 pt-3">
            <div class="content-container" v-if="type == 'poll'">
                <PollResult
                    :question-preview-size="'small'"
                    :question-image="question.image"
                    :image-answer="imageAnswer()"
                    :answers.sync="question.answers"
                    :title="question.title"
                    :userCount="userCount"
                    :playerCount="playerCount"
                    ref="pollResult"
                    user-type="master"
                />
            </div>
            <div class="content-container h-full xl:px-10" v-if="type == 'quiz'">
                <QuizResultMaster
                    @showCorrectAnswer="onShowCorrectAnswer"
                    @showChoices="onShowChoices"
                    :question-preview-size="'small'"
                    :question-image="question.image"
                    :answers="question.answers"
                    :results.sync="quizResults"
                    :correct-answer="correctAnswer"
                    :question-type="question.question_type"
                    :question-required="question.answers_required"
                    :title="question.title"
                    :revealImage="question.question_type === 'reveal_image'"
                    :scaleImage="question.question_type === 'scale_image'"
                    :userCount="userCount.toString()"
                    :playerCount="playerCount.toString()"
                    :currentQuizIndex="playingCurrentQuestionIndex"
                    :questionCount="questionCount"
                    :correctCount="correctCount"
                    :wrongCount="wrongCount"
                    :top3="top3"
                    :setting="masterResultSetting"
                    user-type="master"
                />
            </div>
        </div>
        <div class="footer" :style="{ paddingBottom: type == 'poll' ? '15px' : false }">
            <!-- Begin Mobile Footer -->
            <div v-if="isMobile">
                <div class="flex flex-col items-center justify-center pt-3">
                    <button
                        v-if="!isEndQuiz"
                        @click="handleClickNext"
                        :disabled="!userCount"
                        id="next-btn"
                        class="theme-button btn btn-large uppercase font-size-22 font-opensans"
                    >
                        {{ $t('playlive_master_result_button_next') }}
                    </button>
                    <button
                        v-if="isEndQuiz"
                        @click="handleClickEnd"
                        :disabled="!userCount"
                        id="end-btn"
                        class="theme-button btn btn-large uppercase font-size-22 font-opensans"
                    >
                        {{ $t('playlive_result_button_final') }}
                    </button>
                </div>
            </div>
            <!-- End Mobile Footer -->

            <!-- Begin Desktop Footer -->
            <div v-if="!isMobile" class="flex justify-center items-end px-3">
                <div class="w-1/3">
                    <div class="flex items-end h-12">
                        <a
                            @click="toggleFullScreen"
                            class="theme-ui-text-color cursor-pointer text-white font-size-18 uppercase flex items-center font-bold"
                            type="button"
                        >
                            <i
                                v-if="isFullscreen"
                                class="theme-question-shadow fas fa-compress-arrows-alt font-size-22 mr-1"
                            ></i>
                            <!-- <span v-if="isFullscreen">{{ $t('playlive_button_exit_fullscreen') }} </span> -->
                            <i
                                v-if="!isFullscreen"
                                class="theme-question-shadow fas fa-expand-arrows-alt font-size-22 mr-1"
                            ></i>
                            <!-- <span v-if="!isFullscreen">{{ $t('playlive_button_fullscreen') }}</span> -->
                        </a>
                    </div>
                </div>
                <div class="w-1/3 text-center">
                    <button
                        v-if="!isEndQuiz"
                        @click="handleClickNext"
                        :disabled="!userCount"
                        id="next-btn"
                        class="theme-button btn btn-large uppercase font-size-22 font-opensans"
                    >
                        {{ $t('playlive_master_result_button_next') }}
                    </button>
                    <button
                        v-if="isEndQuiz"
                        @click="handleClickEnd"
                        :disabled="!userCount"
                        id="end-btn"
                        class="theme-button btn btn-large uppercase font-size-22 font-opensans"
                    >
                        {{ $t('playlive_result_button_final') }}
                    </button>
                    <!-- <p class="text-white font-size-18 font-bold uppercase">Answers: {{ userCount }}/{{ playerCount }}</p> -->
                </div>
                <div class="w-1/3">
                    <div class="flex items-end justify-end h-full">
                        <a
                            @click="handleClickCancel"
                            class="theme-ui-text-color uppercase text-white font-bold cursor-pointer font-size-18 inline-flex items-center"
                        >
                            <!-- <span>{{ $t('playlive_button_cancel') }} {{ type }}</span> -->
                            <i class="theme-question-shadow fas fa-times font-size-28 ml-1"></i>
                        </a>
                    </div>
                </div>
            </div>
            <!-- End Desktop Footer -->
        </div>

        <CorrectAnswersPopup
            v-if="isShowCorrectAnswer && correctAnswer"
            @close="isShowCorrectAnswer = false"
            :question="question"
            :showBtnChoices="true"
            :master="true"
            :is-paid-user="isPaidUser"
        />

        <ChoicesPopup v-if="isShowChoices" @close="isShowChoices = false" :question="question" />

        <SocketReconnectModal
            v-if="showMasterPopup"
            @ok="onMasterClickOk"
            :icon="masterPopupIcon"
            :show-footer="true"
            :retry-fail-message="masterRetryFailMessage"
            :ok-button="masterOkButton"
            :title="masterPopupTitle"
            :message="masterPopupMessage"
        />

        <QuizSettingModal
            v-if="showQuizSettingModal"
            @close="handleQuizSetting"
            :delayAnswer="delayAnswer"
            :delayQuestion="delayQuestion"
            :timeLimit="timeLimit"
            :masterSound="masterSound"
            :playerSound="playerSound"
            :progress-bar-status="progressBarStatus"
            :masterResultSetting="masterResultSetting"
        ></QuizSettingModal>
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PollResult from '@/components/PollResult.vue'
import QuizResultMaster from '@/components/QuizResultMaster.vue'
import answer from '@/lib/answer.js'
import popup from '@/lib/popup.js'
import helper from '@/lib/helper.js'
import FullScreen from '@/lib/fullscreen.js'
import preloadSongMixin from '@/mixins/preload-song'
import CorrectAnswersPopup from '@/components/CorrectAnswersPopup.vue'
import QuizHeader from '@/components/QuizHeader.vue'
import ChoicesPopup from '@/components/ChoicesPopup.vue'
import BgMusicMuteBtn from '@/components/BgMusicMuteBtn.vue'
import UserCounter from '@/components/UserCounter.vue'
import SocketReconnectModal from '@/components/SocketReconnectModal.vue'
import socketConnectionMixin from '@/mixins/socket-connection.js'
import QuizSettingModal from '@/components/QuizSettingModal.vue'
import helperMixin from '@/mixins/helper'
import { startIntroMasterResult } from '@/lib/intro.js'
import introJsData from '@/mixins/introjs-data'

export default {
    mixins: [preloadSongMixin, socketConnectionMixin, helperMixin, introJsData],

    components: {
        PollResult,
        QuizResultMaster,
        CorrectAnswersPopup,
        QuizHeader,
        ChoicesPopup,
        BgMusicMuteBtn,
        UserCounter,
        SocketReconnectModal,
        QuizSettingModal
    },

    sockets: {
        user_answered_result: function (data) {
            if (this.type == 'poll') {
                this.question.answers = answer.sanitizePollAnswer(
                    data.result,
                    this.question.answers,
                    this.playingCurrentQuestionIndex
                )
                this.userCount = answer.getPollAnsweredUsers()
                this.$refs.pollResult.updateChart()
            }

            if (this.type == 'quiz') {
                this.quizResults = answer.sanitizeQuizAnswer(data.result, this.playingCurrentQuestionIndex)
                this.userCount = this.quizResults.length

                this.correctCount = this.quizResults.filter(e => e.result === true).length
                this.wrongCount = this.quizResults.filter(e => e.result === false).length
                this.top3 = answer.summarizeQuiz(data.result, data.users).slice(0, 3)
            }

            if (this.userCount && data.toQuizMaster) {
                var clone = this.audioDifinite.cloneNode()

                if ((this.isMuted && this.masterSound.effectMusic) || !this.masterSound.effectMusic) {
                    clone.muted = true
                    this.audioDifinite.muted = true
                } else {
                    clone.muted = false
                    this.audioDifinite.muted = false
                }

                if (this.masterSound.effectMusic) {
                    if (helper.iOS()) {
                        this.audioDifinite.play()
                    } else {
                        clone.play()
                    }
                }
            }
        },

        master_ended_game: function () {
            window.location.href = '/edit/' + this.id
        },

        master_receive_ping: function (user) {
            this.allPlayers[user.name] = new Date()
            this.lastCheckUserAt = new Date()
        }
    },

    created: function () {
        this.resetAnswerScore()
    },

    watch: {
        masterSound: {
            handler(data) {
                if (this.question.spotify_track) {
                    if (!data.questionMusic) {
                        this.handleMute(this.audioSpotify, true)
                    } else {
                        this.handleMute(this.audioSpotify, false)
                    }
                }

                // Effect sound
                if (!data.effectMusic) {
                    this.audioDifinite.muted = true
                } else {
                    this.audioDifinite.muted = false
                }
            },
            deep: true
        }
    },

    mounted: function () {
        let localSetting = JSON.parse(localStorage.getItem('live-quiz-setting'))
        if (localSetting) {
            this.$store.commit('updateDelayAnswer', localSetting.delayAnswer)
            this.$store.commit('updateDelayQuestion', localSetting.delayQuestion)
            this.$store.commit('updateTimeLimit', localSetting.timeLimit)
            this.$store.commit('updateMasterSound', localSetting.masterSound)
            this.$store.commit('updatePlayerSound', localSetting.playerSound)
            this.$store.commit('updateProgressBarStatus', localSetting.progressBarStatus)
            this.$store.commit('updateMasterResultSetting', localSetting.masterResultSetting)

            this.setSocketSetting()
        }

        window.onbeforeunload = function () {
            return 'Are you sure you want to leave this page? You will loose any unsaved actions'
        }

        this.$socket.emit('user_waiting_result', {
            type: this.type,
            room: this.code
        })

        if (this.type == 'poll') {
            //     this.$store.commit('updateRemoveAppPaddingX', true)
        }

        window.addEventListener('unload', this.handleUserCloseWindow)

        this.checkingFullScreen()
        this.checkTypeOfQuestion()

        // Receive custom event componentAlready
        window.addEventListener('componentAlready', () => {
            if (this.$route.name === 'master-result') {
                this.componentsAlreadyCount++

                if (this.componentsAlreadyCount == 2) {
                    this.resizeScaleQuizFrame()
                }
            }
        })

        this.getCurrentUser()

        document.addEventListener('keydown', e => {
            const condition =
                (e.code == 'ArrowRight' || e.code == 'Space') && this.$route.name === 'master-result' && !this.isEndQuiz

            if (condition) {
                this.handleClickNext()
            }
        })

        this.checkMatchMediaScreen()

        setTimeout(() => {
            startIntroMasterResult(this.stepTour6)
        }, 1000)
    },

    destroyed() {
        window.onbeforeunload = function () {}
    },

    data: function () {
        return {
            userCount: 0,
            quizResults: [],
            fullscreen: new FullScreen('.app-wrapper'),
            isFullscreen: false,
            songXhrRequest: null,
            isShowCorrectAnswer: false,
            isShowChoices: false,
            isAlreadyShow: false,
            componentsAlreadyCount: 0,
            popupCurrentRect: null,
            isClickNext: false,
            isClickEnd: false,
            isSoundQuestion: false,

            watchUserTimer: null,
            masterWaitTimer: null,

            correctCount: 0,
            wrongCount: 0,
            top3: [],
            showQuizSettingModal: false,
            isMobile: false
        }
    },

    methods: {
        checkMatchMediaScreen() {
            const match = window.matchMedia('(min-width: 768px)')

            if (match.matches) {
                this.isMobile = false
            } else {
                this.isMobile = true
            }
            match.addEventListener('change', event => {
                if (event.matches) {
                    this.isMobile = false
                } else {
                    this.isMobile = true
                }
            })
        },

        handleUserCloseWindow: function () {
            this.$socket.emit('master_end_game', {
                room: this.code
            })
        },

        handleClickNext: function () {
            if (this.isClickNext) {
                return
            }

            if (!this.userCount) {
                return
            }

            document.querySelector('#next-btn').style.pointerEvents = 'none'
            this.isClickNext = true

            this.$socket.emit('master_press_next', {
                room: this.code,
                questionIndex: this.playingCurrentQuestionIndex
            })

            this.$router.push({
                name: 'master-countdown',
                params: {
                    countAdd: true
                }
            })

            if (!isNaN(this.audioSpotify.duration)) {
                this.audioSpotify.pause()
            }
        },

        handleClickEnd: function (e) {
            document.querySelector('#end-btn').style.pointerEvents = 'none'

            if (this.isClickEnd) {
                return
            }

            this.isClickEnd = true

            if (!this.userCount && e) {
                e.preventDefault()
                return
            }

            this.$socket.emit('master_press_end', {
                room: this.code
            })

            // Toggle when end quiz
            this.$socket.emit('master_press_play_again', {
                room: this.code
            })

            this.$store.dispatch('disableNoSleep')

            this.$router.push({
                name: 'master-summary'
            })

            if (!isNaN(this.audioSpotify.duration)) {
                this.audioSpotify.pause()
            }
        },

        resetAnswerScore: function () {
            this.question.answers.forEach(
                function (answer, index) {
                    this.question.answers[index].score = 0
                }.bind(this)
            )
        },

        imageAnswer: function () {
            return answer.isAllImageAnswer(this.question.answers)
        },

        toggleFullScreen: function () {
            this.fullscreen.toggle({
                type: this.backgroundType,
                image: this.backgroundImage,
                color: this.backgroundColor
            })

            this.checkingFullScreen()
        },

        handleClickCancel: function () {
            const self = this

            window.onbeforeunload = function () {}

            popup.confirm(
                this.$t('playlive_share_alert_cancel', {
                    type:
                        self.type != 'quiz' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')
                }),
                function () {
                    self.$store.commit('setIsQuizNotFinishLogCreated', true)

                    window.location.href = '/edit/' + self.id
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        },

        resizeScaleQuizFrame() {
            // const contentElem = document.getElementsByClassName('content-container')[0]
            const layoutElem = document.getElementsByClassName('layout')[0]
            const headerElem = document.getElementsByClassName('header')[0]
            const footerElem = document.getElementsByClassName('footer')[0]
            const footerHeight = footerElem.getBoundingClientRect().height
            const headerHeight = headerElem.getBoundingClientRect().height
            const uselessHeight = headerHeight + footerHeight

            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            // new ResizeScale({
            //     width: contentElem.getBoundingClientRect().width,
            //     height: contentElem.getBoundingClientRect().height,
            //     child: contentElem,
            //     parent: layoutElem,
            //     uselessHeight: uselessHeight,
            //     noTransForm: false
            // })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')

            this.isAlreadyShow = true
        },

        checkingFullScreen() {
            this.isFullscreen = this.fullscreen.checkFullScreen()
        },

        playSong() {
            if (this.question.spotify_track) {
                const track = this.question.spotify_track
                let audio = this.audioSpotify
                let cachePreviewUrl = track.cache_preview_url ? track.cache_preview_url : track.preview_url

                cachePreviewUrl = cachePreviewUrl.indexOf('mp3') > -1 ? cachePreviewUrl : `${cachePreviewUrl}.mp3`

                this.songXhrRequest = helper.ajaxBlob(
                    cachePreviewUrl,
                    res => {
                        audio.setAttribute('src', res)
                        if (this.masterSound.questionMusic) {
                            this.handleMute(audio, false)
                        }
                    },
                    () => {}
                )
                this.isSoundQuestion = true
            }

            if (this.quiz.questions[this.playingCurrentQuestionIndex + 1]) {
                this.preloadNextSong(this.quiz.questions[this.playingCurrentQuestionIndex + 1])
            }
        },

        checkTypeOfQuestion() {
            // Support old music question
            if (
                !this.question.question_type &&
                this.question.spotify_track &&
                this.question.spotify_track.preview_url
            ) {
                this.playSong()
            }

            switch (this.question.question_type) {
                case 'music':
                    this.playSong()
                    break
            }
        },

        onShowCorrectAnswer(rect) {
            if (rect) {
                this.popupCurrentRect = rect
            }

            this.isShowCorrectAnswer = true
            this.isShowChoices = false

            this.$socket.emit('master_toggle_show_correct_answer', {
                room: this.code,
                questionIndex: this.playingCurrentQuestionIndex,
                isPaidUser: this.isPaidUser
            })
        },

        onShowChoices(rect) {
            if (rect) {
                this.popupCurrentRect = rect
            }

            this.isShowCorrectAnswer = false
            this.isShowChoices = true

            this.$socket.emit('master_toggle_show_answer', {
                room: this.code
            })
        },

        setSocketSetting() {
            this.$socket.emit('master_toggle_play_song_user', {
                room: this.code,
                player_sound: this.playerSound,
                delay_answer: this.delayAnswer,
                delay_question: this.delayQuestion,
                time_limit: this.timeLimit,
                progress_bar_status: this.progressBarStatus
            })

            this.$socket.emit('master_set_setting', {
                room: this.code,
                delayAnswer: this.delayAnswer,
                delayQuestion: this.delayQuestion,
                timeLimit: this.timeLimit,
                masterSound: this.masterSound,
                playerSound: this.playerSound,
                progressBarStatus: this.progressBarStatus,
                masterResultSetting: this.masterResultSetting
            })

            if (this.joinAsPlayer) {
                this.$store.commit('player/toggleQuizPlayerSound', this.playerSound)
                this.$store.commit('player/updateDelayAnswer', this.delayAnswer)
                this.$store.commit('player/updateDelayQuestion', this.delayQuestion)
                this.$store.commit('player/updateTimeLimit', this.timeLimit)
                this.$store.commit('player/updateProgressBarStatus', this.progressBarStatus)
            }
        },

        handleQuizSetting(answerDelay, questionDelay, timeLimit, master, player, progressBarStatus, masterResult) {
            let liveQuizSetting = {
                delayAnswer: answerDelay,
                delayQuestion: questionDelay,
                timeLimit: timeLimit,
                masterSound: master,
                playerSound: player,
                progressBarStatus: progressBarStatus,
                masterResultSetting: masterResult
            }
            localStorage.setItem('live-quiz-setting', JSON.stringify(liveQuizSetting))
            this.$store.commit('updateDelayAnswer', answerDelay)
            this.$store.commit('updateDelayQuestion', questionDelay)
            this.$store.commit('updateTimeLimit', timeLimit)
            this.$store.commit('updateMasterSound', master)
            this.$store.commit('updatePlayerSound', player)
            this.$store.commit('updateProgressBarStatus', progressBarStatus)
            this.$store.commit('updateMasterResultSetting', masterResult)
            this.setSocketSetting()
            this.showQuizSettingModal = false
        },

        openLiveShare() {
            window.open(`/live/${this.code}`, '_blank')
        }
    },

    computed: {
        ...mapGetters({
            question: 'getCurrentQuiz',
            isEndQuiz: 'isEndQuiz',
            questionCount: 'getQuestionCount',
            audioDifinite: 'getDifiniteAudio',
            audioSpotify: 'getSpotifyAudio',
            masterSound: 'getMasterSound',
            isQuizNotFinishLogCreated: 'isQuizNotFinishLogCreated',
            delayAnswer: 'getDelayAnswer',
            delayQuestion: 'getDelayQuestion',
            timeLimit: 'getTimeLimit',
            playerSound: 'getPlayerSound',
            progressBarStatus: 'getProgressBarStatus',
            masterResultSetting: 'getMasterResultSetting',
            orderAbility: 'orderAbility'
        }),

        ...mapState({
            quiz: state => state.question,
            id: state => state.question._id,
            code: state => state.question.code,
            title: state => state.question.title,
            type: state => state.question.type,
            playerCount: state => state.playerCount,
            playingCurrentQuestionIndex: state => state.playingCurrentQuestionIndex,
            backgroundType: state => state.question.background_type,
            backgroundImage: state => state.question.background_image,
            backgroundColor: state => state.question.background_color,
            isPlayTogether: state => state.player.isPlayTogether,
            quizId: state => state.quizId,
            isMuted: state => state.isMuted
        }),

        correctAnswer: function () {
            let transformCorrectAnswerData = []
            let self = this

            self.question.answers.map((answer, index) => {
                const condition = self.question.question_type != 'sorting_list' ? answer.is_correct : true
                if (condition) {
                    transformCorrectAnswerData.push({
                        title: self.question.answers[index].title,
                        image: self.question.answers[index].image
                    })
                }
            })
            return transformCorrectAnswerData
        },

        isPaidUser() {
            return this.orderAbility.is_24hrs_access || this.orderAbility.has_subscribed
        }
    },

    beforeRouteLeave(to, from, next) {
        let self = this

        window.onbeforeunload = function () {}

        if (this.songXhrRequest) {
            this.handleMute(this.audioSpotify, false)

            setTimeout(() => {
                this.songXhrRequest.abort()
            }, 500)
        }

        if (to.name === 'master-countdown' || to.name === 'master-summary') {
            next()
        } else {
            next(false)
            popup.confirm(
                this.$t('playlive_share_alert_cancel', {
                    type:
                        this.type != 'quiz' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')
                }),
                function () {
                    self.$store.commit('setIsQuizNotFinishLogCreated', true)

                    self.$socket.emit('master_end_game', {
                        room: self.code
                    })

                    next()
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.layout {
    height: calc(100vh - 2rem);
    height: calc((var(--vh, 1vh) * 103) - 2rem);
    margin-top: -1rem;
    margin-right: -1rem;
    margin-left: -1rem;

    @media screen and (max-width: 1199px) {
        height: calc((var(--vh, 1vh) * 102) - 2rem);
    }

    @media (max-width: 575px) {
        height: calc(100vh);
        height: calc((var(--vh, 1vh) * 100) - 1rem);
    }

    @media (max-width: 320px) {
        height: calc(100vh);
        height: calc((var(--vh, 1vh) * 100));
    }
}

.header-tool {
    top: 0;
    right: 0;
}

.setting-icon {
    top: 0;
    right: 0;
}

.btn {
    padding: 0.6rem 1.5rem;
}

@media screen and (min-width: 768px) and (max-width: 1920px) {
    section.layout .content {
        // overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
}

@media screen and (max-width: 767px) {
    section.layout .content {
        overflow-x: hidden;
        overflow-y: auto;
        height: calc(100% - var(--useless-h));
    }

    section.layout .footer {
        padding: 0;
    }

    .margin-l15 {
        margin-left: 15px;
    }
}

@media screen and (max-width: 362px) {
    .footer button {
        font-size: calc(1vw + 2vh);
        padding: calc(1vw + 1vh) calc(1vw + 1vh);
    }
}
</style>
